import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.promise";
import "core-js/modules/es6.object.assign";
import "core-js/modules/es7.promise.finally";
export default {
  type: 'catalog_order',
  aliases: ['demande'],
  slices: [{
    name: 'catalog_form',
    path: 'CatalogOrder/FormCatalog.vue'
  }]
};